import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

export const extendQuotaOffer: boolean = !IS_WEBVIEW && (isFeature('extend-quota-offer') || false);

export const extendQuotaOfferLimit: number = getFeature('extend-quota-offer-limit') || 80;
export const extendQuotaOfferShowInterval: number = getFeature('extend-quota-offer-show-interval') || 30;

type ExtendQuotaOfferTariffs = {
    year: string;
    month: string;
};

export const extendQuotaOfferTariffs: ExtendQuotaOfferTariffs = getFeature('extend-quota-offer-tariffs') || {
    month: 'W512GB_1m_transfer_to_bigger_discount',
    year: 'W512GB_1y_transfer_to_bigger_discount',
};

if (!IS_WEBVIEW) {
    registerExperiment(
        '512-extend',
        'b',
        [
            AnalyticEventNames.EXTEND_QUOTA_OFFER_SHOW,
            AnalyticEventNames.EXTEND_QUOTA_OFFER_PRIMARY_CLICK,
            AnalyticEventNames.EXTEND_QUOTA_OFFER_SECONDARY_CLICK,
            AnalyticEventNames.EXTEND_QUOTA_OFFER_CLOSE,
        ],
        {
            mapEventNames: {
                EXTEND_QUOTA_OFFER_SHOW: 'show',
                EXTEND_QUOTA_OFFER_PRIMARY_CLICK: 'primary',
                EXTEND_QUOTA_OFFER_SECONDARY_CLICK: 'secondary',
                EXTEND_QUOTA_OFFER_CLOSE: 'close',
            },
        }
    );
}
